import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NavigationService } from 'src/app/modules/booking/services/navigation.services';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { GiftCardStepEnum } from '../../models/giftcard-step.enum';
import { GiftCardStepService } from '../../services/giftcard-step.service';

@Component({
  selector: 'app-giftcard',
  templateUrl: './giftcard.component.html',
  styleUrls: ['./giftcard.component.css']
})
export class GiftcardComponent implements OnInit, OnDestroy {

  private initializeSubscription: Subscription;
  private _loading = false;

  constructor(
    private router: Router,
    private giftcardStepService: GiftCardStepService,
    private loadingSpinnerService: LoadingSpinnerService,
    private navigationService :NavigationService,
  ) {
  }

  ngOnInit(): void {
    this.loading = true;
    if (this.giftcardStepService.step !== GiftCardStepEnum.SelectGiftCard) {
      this.initializeSubscription = this.giftcardStepService.initialize()
        .subscribe(
          () => {
            if (this.giftcardStepService.unlimitedAmount) {
              this.giftcardStepService.forward();
            }
            this.loading = false;
          }
        );
    } else {
      this.loading = false;
    }
  }

  ngOnDestroy(): void {
    if (this.initializeSubscription) {
      this.initializeSubscription.unsubscribe();
      this.initializeSubscription = null;
    }
    this.loading = false;
  }


  get loading(): boolean {
    return this._loading;
  }

  set loading(value: boolean) {
    if (this._loading === value) {
      return;
    }

    this._loading = value;
    if (value) {
      this.loadingSpinnerService.show();
    } else {
      this.loadingSpinnerService.hide();
    }
  }

  onBack(): void {
    this.router.navigateByUrl('');
  }

  get hideBack(): boolean {
    return this.navigationService.onlyGifts;
  }
}
